import RequestedProductType from "./requestedProductType";

export default RequestedProductType; 
export * from "./requestedProductType";